<form #form="ngForm">
    <!-- <p><b>Version Informationen</b></p> -->
    <div [class]="{ 'mini-grid-product-type': !isVersionEditMode(), 'mgn-btn': isVersionEditMode() }">
        <mat-form-field class="fullWidth">
            <mat-label>Versionsname</mat-label>
            <input matInput #versionNameCtrl="ngModel" [(ngModel)]="this.version.name"
                name="versionName" [disabled]="isVersionEditMode() && !isCreateNew" required maxlength="160" minlength="2"
                [ngModelOptions]="{ updateOn: 'change' }" [errorStateMatcher]="versionNameErrorStateMatcher" />
            <mat-icon matSuffix class="info-icon"
                matTooltip="Bezeichnet die technische Entwicklungsstufe oder Release-Version innerhalb einer Variante. Beispiel: Version 2.1, 2025.3, Winter Release, 2014. Verschiedene Versionen können unterschiedliche Produkttypen und Features haben und durch den Anwender verglichen werden (Varianten Vergleich). Zusätzliche Versionen können Sie nach Bedarf im Bereich Einstellungen / Produkte ergänzen."
                matTooltipPosition="above" tabindex="-1">
                info_outline
            </mat-icon>
            <mat-error>
                {{ utilService.getErrorMessage(versionNameCtrl, {fieldName:'Versions', includeMinLength: true}) }}
            </mat-error>
        </mat-form-field>
        <!-- <mat-form-field class="fullWidth">
            <input
                matInput
                #versionNameCtrl="ngModel"
                [(ngModel)]="this.version.description"
                placeholder="Versionsbeschreibung"
                name="versionDescription"
                [attr.disabled]="true"
                required
                maxlength="1600"
                [ngModelOptions]="{ updateOn: 'change' }"
                [errorStateMatcher]="versionNameErrorStateMatcher"
            />
            <mat-error>
                {{ utilService.getErrorMessage(versionNameCtrl, {fieldDescription:'Versionsbeschreibung'}) }}
            </mat-error>
        </mat-form-field> -->

        <div [class]="{ 'mini-grid-status-preversion': isVersionEditMode() }">
            <mat-form-field>
                <mat-label>Status der Version</mat-label>
                <mat-select [(ngModel)]="version.status" name="versionStatus">
                    <mat-option [value]="Status.ACTIVE">Aktiv</mat-option>
                    <mat-option [value]="Status.INACTIVE">Inaktiv</mat-option>
                </mat-select>
                <mat-icon matSuffix class="info-icon"
                    matTooltip="Inaktiv: Diese Version wird vom Hersteller nicht mehr unterstützt und ist auf BIMSWARM nicht mehr sichtbar. Aktiv: Dies ist eine aktuelle Version. Wenn dem Produkt ein Abonnement zugeordet ist, ist es sichtbar auf BIMSWARM."
                    matTooltipPosition="above" tabindex="-1">
                    info_outline
                </mat-icon>
            </mat-form-field>
            <mat-form-field *ngIf="isVersionEditMode()">
                <mat-label>Vorgängerversion</mat-label>
                <mat-select [(ngModel)]="version.previousVersion" name="previousVersions"
                    (selectionChange)="
                        onAddAttributeValidationsFromOtherVersion($event)
                    " [disabled]="isCreateNew">
                    <mat-option *ngFor="
                            let variantVersion of allVersionsOfActiveVariant
                        " [value]="variantVersion.id">{{ variantVersion.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- <addEntriesToList-panel
        [(keywords)]="version.keywords"
        [editable]="true"
        [keywordPanel]="true"
    ></addEntriesToList-panel> -->

    </div>
    <div *ngIf="isVariantCreateMode()" class="mini-grid-dependency">
        <div class="mikro-grid-ptg">
            <p *ngIf="isCertification; else productDependencyText">
                Sollen für diese Version Merkmale einer anderen
                Zertifizierungsversion übernommen werden?
            </p>
            <ng-template #productDependencyText>
                <p style="margin-top: 12px;">
                    Sollen für diese Version Produkttypen einer anderen
                    Produktversion übernommen werden?
                </p>
            </ng-template>
            <mat-slide-toggle [checked]="addOtherVersionAttributesMode"
                (change)="addOtherVersionAttributesModeToggle($event.checked)">
            </mat-slide-toggle>
        </div>
        <div [class]="{
                hide: !addOtherVersionAttributesMode}">
            <div class="previous-version-panel-second">
                <mat-form-field>
                    <mat-label>Variante</mat-label>
                    <mat-select (selectionChange)="setDependeeVariant($event)" #variantReference>
                        <mat-option *ngFor="let variant of getOtherVariantsOfEntity()" value="{{ variant.id }}">
                            {{ variant.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Version</mat-label>
                    <mat-select (selectionChange)="
                            onAddAttributeValidationsFromOtherVersion($event)
                        " #versionReference>
                        <mat-option *ngFor="
                                let version of filterSelectedVariant(
                                    variantReference.value,
                                    variantReference.selected === undefined
                                )
                            " value="{{ version.id }}">{{ version.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>

    <!-- <div *ngIf="isVersionEditMode()">
        <mat-form-field class="fullWidth">
            <textarea
                matInput
                [(ngModel)]="version.comment"
                placeholder="Kommentar (intern)"
                name="comment"
            ></textarea>
        </mat-form-field>
        <app-text-editor
            [(editorText)]="version.description"
            (textValidityChange)="onDescriptionValidityChange($event)"
        ></app-text-editor>
    </div> -->

    <!-- new Desing for product create form -->
    <app-add-ptg-dependency-table *ngIf="!isCertificationEditMode() && (isVersionEditMode() || isVariantCreateMode())"
        [isCertification]="isCertification" [version]="version" [selectedCategory]="selectedCategory"
        (addedPtgVersion)="onPtgVersionAdded($event)"
        (removedPtgVersion)="onPtgVersionRemoved($event)"></app-add-ptg-dependency-table>

    <div *ngIf="!isCertificationEditMode() && (isVersionEditMode() || isVariantCreateMode())" class="feature-container">
        <h3>Funktionen und Features*</h3>

        <div *ngIf="version?.ptgVersions.length === 0">
            <p class="info-text">Wählen Sie mindestens einen passenden Produkttyp für Ihr Produkt aus.</p>
        </div>
        <ng-container *ngFor="let ptgVersion of version?.ptgVersions;  let i = index">
            <app-attribute-validation-panel [ptgName]="getPtgName(ptgVersion)"
                [attributes]="getNonOptionalAttributesOfPtgVersion(ptgVersion)" [optional]="false" [editable]="false"
                [showOrderControls]="true" [canMoveUp]="canMoveUp(i)" [canMoveDown]="canMoveDown(i)" [position]="i"
                (moveUp)="moveUp(i)" (moveDown)="moveDown(i)" (attributesChanged)="onAttributesChanged($event, i)">
            </app-attribute-validation-panel>
        </ng-container>
    </div>

    <!-- Temporary with *ngIf="isCertification", certification form and prozess has to be checked!-->
    <app-add-ptg-dependency-panel *ngIf="!isCertificationEditMode()" [isCertification]="isCertification"
        [version]="version" (addedPtgVersion)="onPtgVersionAdded($event)"></app-add-ptg-dependency-panel>

    <app-selected-ptg-panel *ngIf="!isCertificationEditMode()" [version]="version"
        [catalogueAttributes]="catalogueAttributes" (changedPtgVersions)="onPtgVersionsChanged($event)">
    </app-selected-ptg-panel>

    <ng-container *ngIf="isCertification">
        <ng-container *ngFor="let ptgVersion of version.ptgVersions">
            <p>
                <b>
                    Merkmale aus Produkttyp {{ getPtgName(ptgVersion) }} - Version
                    {{ ptgVersion.number }}
                </b>
            </p>
            <p>Verpflichtende Merkmale:</p>
            <attribute-validation-table [attributes]="getNonOptionalAttributesOfPtgVersion(ptgVersion)"
                [optional]="false" [editable]="false">
            </attribute-validation-table>
            <p>Optionale Merkmale:</p>
            <attribute-validation-table [attributes]="getOptionalAttributesOfPtgVersion(ptgVersion)" [optional]="true"
                [editable]="false">
            </attribute-validation-table>
        </ng-container>
    </ng-container>

    <div *ngIf="!isCertificationEditMode()" class="min-auto mini-grid-dependency">
        <p>
            <!-- <p *ngIf="isCertification; else productText"> -->
            <strong>
                Merkmale für die Zertifizierungsversion hinzufügen
            </strong>
        </p>
        <!-- <ng-template #productText>
            <div>
                <p>Merkmale für die Produktversion hinzufügen</p>
            </div>
            <div>
                <attribute-catalogue
                (onPressConfirm)="featureCatalogueConfirmPressed($event)"
                [noMargin]="true"
            ></attribute-catalogue>
            </div>
        </ng-template> -->
        <attribute-catalogue *ngIf="isCertification;" (onPressConfirm)="featureCatalogueConfirmPressed($event)"
            [noMargin]="true"></attribute-catalogue>
    </div>

    <attribute-validation-table *ngIf="isCertification" [attributes]="catalogueAttributes" [editable]="true"
        (attributesChanged)="onAttributesChanged($event)">
    </attribute-validation-table>


</form>
